export const dateConstants = [
  { label: 'Lifetime', value: '' },
  { label: 'Month To Date', value: 'month' },
  { label: 'Week To Date', value: 'week' },
  { label: 'Today', value: 'day' },
]

export const limitConstants = [
  { label: '5', value: 5 },
  { label: '10', value: 10 },
  { label: '15', value: 15 },
  { label: '20', value: 20 },
  { label: '25', value: 25 },
  { label: '30', value: 30 },
  { label: '35', value: 35 },
  { label: '40', value: 40 },
  { label: '45', value: 45 },
  { label: '50', value: 50 }
]
